<div class="work-step-scheduler-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="calendarIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "workorder.ui.scheduleinbulk.header.label" | translate }}
      </div>
    </span>
  </div>
  <div class="work-step-scheduler-mat-dialog-body">
    <div class="flex--col p-r--16" style="border-right: 1px solid #e3e3e3">
      <div class="messages-container gap--8 m-b--8 flex--r-c info">
        <mat-icon>info</mat-icon>
        {{ "workorder.ui.scheduleinbulk.helpertext" | translate }}
      </div>
      <div class="default-max-width">
        <lib-w-h-datetime-picker
          [parentFormGroup]="tempFormGroup"
          startDateForm="dateSlotForm"
          startTimeForm="timeSlotForm"
          endDateForm="enddateSlotForm"
          endTimeForm="endtimeSlotForm"
          [hasEndDate]="true"
          [futureDate]="true"
          [hasTimer]="true"
          [startDateLabel]="'workstep.model.startdate'"
          [endDateLabel]="'workstep.model.enddate'"
        ></lib-w-h-datetime-picker>
      </div>
      <mat-slide-toggle
        #slideToggle
        [checked]="true"
        (change)="toggleScheduleMode($event)"
        color="accent"
      >
        {{ "workorder.ui.scheduleinbulk.applytounscheduled.label" | translate }}
      </mat-slide-toggle>
    </div>

    <div class="flex--c-c-fs">
      <form [formGroup]="remindTechnicianFormGroup" class="w-100">
        <div class="remind-technician-grid">
          <span class="flex-1 column-height">
            <div class="w-h-label html-overflow">
              {{
                "technicianNotification.label.notificationInterval" | translate
              }}
            </div>
            <lib-w-h-dropdown
              class="remind-technician-dropdown"
              [itemKeys]="['displayName']"
              [subItemKey]="'subItem'"
              [loading]="remindTechnicianFormGroup.disabled"
              [value]="'value'"
              [valueFormControl]="
                remindTechnicianFormGroup.get('reminderOffsetInMinutes')
              "
              [dropdownItemDomList]="alertOptions"
            >
            </lib-w-h-dropdown>
          </span>

          <span class="flex-1 flex--col">
            <div
              class="w-h-label header-margin html-overflow"
              style="text-align: center"
            >
              {{ "technicianNotification.label.notificationTime" | translate }}
            </div>

            @if (notificationTimeInfo()) {
              <div class="flex-1 flex--r-c-c" [@dynamicAnimation]="'left'">
                {{
                  notificationTimeInfo() | date: "short" : "" : currentLocale()
                }}
              </div>
            }
          </span>
        </div>

        <mat-form-field>
          <mat-label>{{
            "workobject.model.contactclient.comment" | translate
          }}</mat-label>

          <textarea [rows]="3" matInput formControlName="reminderComment">
          </textarea>
        </mat-form-field>
      </form>
    </div>
  </div>
  <w-h-button-group align="end" mat-dialog-actions>
    <w-h-button
      [text]="'app.cancel.label' | translate | uppercase"
      matIcon="close"
      (clicked)="closeDialog()"
    />
    <w-h-button
      [text]="'app.save.label' | translate | uppercase"
      matIcon="save"
      color="accent"
      type="flat"
      [disabled]="!dateSet"
      (clicked)="handleSubmit()"
    />
  </w-h-button-group>
</div>
